import { ArrowRight, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSiteContent } from '../content/ContentContext';

export default function Hero() {
  const {
    content: { site },
  } = useSiteContent();

  return (
    <section className="relative isolate overflow-hidden bg-slate-900">
      <img
        src={site.heroImage}
        alt={site.heroImageAlt}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/65 to-black/40" />
      <div className="relative mx-auto grid min-h-[72vh] max-w-7xl items-center gap-10 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:px-8 lg:py-28">
        <div className="max-w-3xl text-white">
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.2em] text-[#7dff45]">{site.heroEyebrow}</p>
          <h1 className="text-4xl font-black leading-tight sm:text-5xl lg:text-6xl">{site.heroTitle}</h1>
          <p className="mt-6 max-w-2xl text-lg leading-8 text-white/90">{site.heroDescription}</p>
          <div className="mt-8 flex flex-col gap-4 sm:flex-row">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#33b300] px-6 py-4 text-base font-bold text-white transition hover:bg-[#289000]"
            >
              Request a Free Estimate <ArrowRight size={18} />
            </Link>
            <a
              href={site.phoneHref}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 bg-white/10 px-6 py-4 text-base font-bold text-white transition hover:bg-white/20"
            >
              <Phone size={18} /> Call {site.phoneDisplay}
            </a>
          </div>
          <p className="mt-5 text-sm font-medium text-white/85">Proudly serving {site.serviceArea}.</p>
        </div>
      </div>
    </section>
  );
}
